<template>
  <div class="tasks">
    <h1>任务管理</h1>

    <!-- 今日运营概览 -->
    <el-row :gutter="12" style="margin-bottom: 16px">
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="ov-card">
          <div class="ov-num">{{ overview.monitor_runs || 0 }}</div>
          <div class="ov-label">🛰️ 今日自动监控</div>
          <div class="ov-sub">同行作品监控次数</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="ov-card">
          <div class="ov-num">{{ overview.live_watch_runs || 0 }}</div>
          <div class="ov-label">📡 今日开播雷达</div>
          <div class="ov-sub">扫描博主开播次数</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="ov-card">
          <div class="ov-num">{{ overview.collected_today || 0 }}</div>
          <div class="ov-label">🎯 今日采集评论</div>
          <div class="ov-sub">A{{ overview.intent_today?.A || 0 }} / B{{ overview.intent_today?.B || 0 }} / C{{ overview.intent_today?.C || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="ov-card">
          <div class="ov-num">{{ overview.pending_ab || 0 }}</div>
          <div class="ov-label">⏳ 待处理意向</div>
          <div class="ov-sub">A/B级未留痕</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="ov-card">
          <div class="ov-num">{{ (overview.processed?.traced || 0) + (overview.processed?.followed || 0) }}</div>
          <div class="ov-label">🤝 已留痕/关注</div>
          <div class="ov-sub">私信成功 {{ overview.processed?.dm_sent || 0 }} / 拦截 {{ overview.processed?.dm_blocked || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4">
        <el-card shadow="hover" class="ov-card">
          <div class="ov-num">{{ overview.live_capture_runs || 0 }}</div>
          <div class="ov-label">🔴 直播间截流</div>
          <div class="ov-sub">弹幕采集次数</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 定时巡猎（2026-08-30：采集定时巡猎） -->
    <el-card style="margin-bottom: 16px">
      <template #header>
        <div class="card-header">
          <span>⏰ 定时巡猎 <span style="color:#909399;font-size:12px;font-weight:normal">到点自动执行自动巡猎，无需手动启动</span></span>
          <el-button type="primary" size="small" @click="openHuntDialog(true)">+ 新建定时巡猎</el-button>
        </div>
      </template>
      <el-table :data="scheduledHunts" style="width: 100%" v-loading="shLoading" empty-text="暂无定时巡猎任务，点击右上角新建">
        <el-table-column prop="name" label="名称" width="150" />
        <el-table-column label="平台" width="90">
          <template #default="scope">
            <el-tag :type="platformType(scope.row.platform)" size="small">{{ platformText(scope.row.platform) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号ID" width="80" prop="account_id" />
        <el-table-column label="关键词" min-width="180" show-overflow-tooltip>
          <template #default="scope">{{ (scope.row.keywords || []).join(' / ') }}</template>
        </el-table-column>
        <el-table-column label="频率" width="150">
          <template #default="scope">
            <el-tag size="small" type="info">{{ scope.row.schedule_type === 'daily' ? `每日 ${scope.row.time_of_day}` : `每 ${scope.row.interval_minutes} 分钟` }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="互动" width="70">
          <template #default="scope">
            <el-tag size="small" :type="scope.row.interact ? 'danger' : 'info'">{{ scope.row.interact ? '🎯开' : '关' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="下次运行" width="160">
          <template #default="scope">{{ scope.row.next_run_at || '—' }}</template>
        </el-table-column>
        <el-table-column label="已跑" width="70" prop="run_count" />
        <el-table-column label="状态" width="90">
          <template #default="scope">
            <el-switch :model-value="scope.row.enabled" @change="toggleScheduledHunt(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170">
          <template #default="scope">
            <el-button size="small" type="success" @click="runScheduledHuntNow(scope.row)">立即运行</el-button>
            <el-button size="small" type="danger" @click="deleteScheduledHunt(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card>
      <template #header>
        <div class="card-header">
          <span>任务列表</span>
          <div class="hdr-actions">
            <el-select v-model="filterPlatform" size="small" style="width: 110px; margin-right: 8px" @change="loadTasks()">
              <el-option label="全部平台" value="" />
              <el-option label="抖音" value="douyin" />
              <el-option label="快手" value="kuaishou" />
            </el-select>
            <el-button type="primary" @click="openHuntDialog">🤖 自动巡猎获客</el-button>
            <el-button type="success" @click="showSelfHeatDialog = true">🔥 自热互动</el-button>
            <el-button type="warning" @click="showLiveDialog = true">🔴 直播间截流</el-button>
            <el-button type="danger" @click="showDmDialog = true">✉️ 私信触发</el-button>
            <el-button type="success" @click="showCollectDialog = true">
              🎯 一键采集线索
            </el-button>
            <el-button type="primary" @click="showCreateDialog = true">
              创建任务
            </el-button>
          </div>
        </div>
      </template>

      <el-table :data="tasks" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="平台" width="90">
          <template #default="scope">
            <el-tag :type="platformType(scope.row.platform)" size="small">
              {{ platformText(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template #default="scope">{{ typeText(scope.row.task_type) }}</template>
        </el-table-column>
        <el-table-column prop="account_id" label="账号ID" />
        <el-table-column prop="target_url" label="目标URL" show-overflow-tooltip />
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="result" label="结果" show-overflow-tooltip />
        <el-table-column prop="created_at" label="创建时间" />
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button
              size="small"
              type="danger"
              :disabled="['completed','failed','cancelled'].includes(scope.row.status)"
              @click="cancelTask(scope.row)"
            >
              取消
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- Create Task Dialog -->
    <el-dialog v-model="showCreateDialog" title="创建任务" width="520px">
      <el-form :model="newTask" label-width="100px">
        <el-form-item label="任务类型">
          <el-select v-model="newTask.task_type" style="width: 100%">
            <el-option label="关注" value="follow" />
            <el-option label="点赞" value="like" />
            <el-option label="评论" value="comment" />
            <el-option label="私信" value="message" />
            <el-option label="浏览" value="view" />
            <el-option label="采集评论" value="collect_comments" />
          </el-select>
        </el-form-item>
        <el-form-item label="账号">
          <el-select v-model="newTask.account_id" style="width: 100%">
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="`${account.username} (${account.nickname})`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="目标URL">
          <el-input v-model="newTask.target_url" placeholder="https://www.douyin.com/video/... 或用户主页" />
        </el-form-item>
        <el-form-item label="提示">
          <span style="color:#909399; font-size:12px">任务创建后由后台引擎自动执行，无需等待</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showCreateDialog = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="createTask">确认</el-button>
      </template>
    </el-dialog>

    <!-- Collect Comments Dialog -->
    <el-dialog v-model="showCollectDialog" title="一键采集线索" width="520px">
      <el-form :model="collectForm" label-width="100px">
        <el-form-item label="执行账号">
          <el-select v-model="collectForm.account_id" style="width: 100%">
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="`${account.username} (${account.nickname})${account.is_logged_in ? ' ✅已登录' : ''}`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="视频URL">
          <el-input v-model="collectForm.video_url" placeholder="https://www.douyin.com/video/xxxxxxxx" />
        </el-form-item>
        <el-form-item label="采集数量">
          <el-input-number v-model="collectForm.max_comments" :min="50" :max="500" :step="50" />
        </el-form-item>
        <el-form-item label="说明">
          <span style="color:#909399; font-size:12px">自动抓取评论 → 关键词识别高意向客户 → 线索自动入库</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showCollectDialog = false">取消</el-button>
        <el-button type="success" :loading="collecting" @click="submitCollect">开始采集</el-button>
      </template>
    </el-dialog>

    <!-- DM Followup Dialog -->
    <el-dialog v-model="showDmDialog" title="✉️ 精准私信触发" width="520px">
      <el-form :model="dmForm" label-width="100px">
        <el-form-item label="执行账号">
          <el-select v-model="dmForm.account_id" style="width: 100%">
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="`${account.username} (${account.nickname})${account.is_logged_in ? ' ✅已登录' : ''}`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="私信数量">
          <el-input-number v-model="dmForm.max_leads" :min="1" :max="50" />
        </el-form-item>
        <el-form-item label="说明">
          <span style="color:#909399; font-size:12px">只对已留痕且高意向线索私信（差异化话术+落地页链接），自动跳过无互动客户</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showDmDialog = false">取消</el-button>
        <el-button type="danger" :loading="dmSending" @click="submitDm">开始私信</el-button>
      </template>
    </el-dialog>

    <!-- Live Capture Dialog -->
    <el-dialog v-model="showLiveDialog" title="🔴 直播间截流" width="520px">
      <el-form :model="liveForm" label-width="100px">
        <el-form-item label="执行账号">
          <el-select v-model="liveForm.account_id" style="width: 100%">
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="`${account.username} (${account.nickname})${account.is_logged_in ? ' ✅已登录' : ''}`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="直播间URL">
          <el-input v-model="liveForm.live_url" placeholder="https://live.douyin.com/xxxxx" />
        </el-form-item>
        <el-form-item label="采集时长(秒)">
          <el-input-number v-model="liveForm.duration" :min="30" :max="600" :step="30" />
        </el-form-item>
        <el-form-item label="说明">
          <span style="color:#909399; font-size:12px">进入直播间抓取意向弹幕用户入库（Web端可见弹幕，实时协议级抓取受限）</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showLiveDialog = false">取消</el-button>
        <el-button type="warning" :loading="liveSending" @click="submitLive">开始采集</el-button>
      </template>
    </el-dialog>

    <!-- 自热互动 Dialog（2026-08-30：自己作品评论自动回复 + 新粉丝自动回关） -->
    <el-dialog v-model="showSelfHeatDialog" title="🔥 自热互动（维护自己账号热度）" width="520px">
      <el-form :model="selfHeatForm" label-width="110px">
        <el-form-item label="执行账号">
          <el-select v-model="selfHeatForm.account_id" style="width: 100%">
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="`${account.username} (${account.nickname})${account.is_logged_in ? ' ✅已登录' : ''}`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="回复评论数">
          <el-input-number v-model="selfHeatForm.max_replies" :min="1" :max="30" />
        </el-form-item>
        <el-form-item label="回关粉丝数">
          <el-input-number v-model="selfHeatForm.max_follows" :min="1" :max="30" />
        </el-form-item>
        <el-form-item label="说明">
          <span style="color:#909399;font-size:12px">自动检查自己作品的新评论 → AI 话术回复（引导私信）；自动检查新粉丝 → 回关（互关后私信更安全）。防重记账，同一用户只处理一次。</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showSelfHeatDialog = false">取消</el-button>
        <el-button type="success" :loading="selfHeatSending" @click="submitSelfHeat">开始自热互动</el-button>
      </template>
    </el-dialog>

    <!-- Auto-Hunt Dialog -->
    <el-dialog v-model="showHuntDialog" title="🤖 自动巡猎获客" width="560px">
      <el-form :model="huntForm" label-width="100px">
        <el-form-item label="平台">
          <el-radio-group v-model="huntForm.platform">
            <el-radio-button value="douyin">抖音</el-radio-button>
            <el-radio-button value="kuaishou">快手</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="执行账号">
          <el-select v-model="huntForm.account_id" style="width: 100%" :disabled="!huntForm.platform">
            <el-option
              v-for="account in accountsByPlatform"
              :key="account.id"
              :label="`${account.username} (${account.nickname})${account.is_logged_in ? ' ✅已登录' : ''}`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="获客入口">
          <el-radio-group v-model="huntForm.source_type">
            <el-radio-button value="search">🔍 搜索关键词</el-radio-button>
            <el-radio-button value="following">👥 关注列表</el-radio-button>
            <el-radio-button value="recommend">📱 推荐页</el-radio-button>
            <el-radio-button value="liked">❤️ 喜欢列表</el-radio-button>
            <el-radio-button value="specific">🔗 指定视频</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="huntForm.source_type === 'specific'" label="视频链接">
          <el-input
            v-model="huntForm.source"
            type="textarea"
            :rows="3"
            placeholder="每行一个抖音视频链接，如 https://www.douyin.com/video/7xxxxxx"
          />
        </el-form-item>
        <el-form-item v-else-if="huntForm.source_type !== 'search'" label="说明">
          <span style="color:#909399;font-size:12px">
            {{ huntForm.source_type === 'following' ? '从你关注的同行作品信息流中抓取高流量视频' : huntForm.source_type === 'recommend' ? '从首页推荐信息流中抓取视频（可能含非同行内容）' : '从你自己点赞过的视频中抓取（都是你关注过的优质同行）' }}
          </span>
        </el-form-item>
        <el-form-item v-if="huntForm.source_type === 'search'" label="行业关键词">
          <el-input
            v-model="huntForm.keywordsText"
            type="textarea"
            :rows="4"
            placeholder="每行一个关键词，如：&#10;本地生活&#10;餐饮门店&#10;汽车美容"
          />
        </el-form-item>
        <el-form-item label="每词视频数">
          <el-input-number v-model="huntForm.max_videos" :min="1" :max="15" />
        </el-form-item>
        <el-form-item label="每视频评论">
          <el-input-number v-model="huntForm.max_comments" :min="20" :max="200" :step="10" />
        </el-form-item>
        <el-form-item label="🎯 评论区互动">
          <el-switch v-model="huntForm.interact" />
          <span style="margin-left:10px;color:#909399;font-size:12px">对意向客户：点赞评论 + AI 话术回复（引导私信）</span>
        </el-form-item>
        <el-form-item v-if="huntForm.interact" label="每轮互动数">
          <el-input-number v-model="huntForm.max_interact" :min="1" :max="30" />
        </el-form-item>
        <el-form-item label="💬 视频评论">
          <el-switch v-model="huntForm.video_comment" />
          <span style="margin-left:10px;color:#909399;font-size:12px">对博主作品发表 AI 评论（真诚请教，同行交流）</span>
        </el-form-item>
        <el-form-item v-if="huntForm.video_comment" label="评论图片">
          <el-input v-model="huntForm.comment_image" placeholder="本地图片绝对路径，如 C:\images\demo.jpg（可选，有图有真相）" />
        </el-form-item>
        <el-divider content-position="left">🛡 视频筛选（可选）</el-divider>
        <el-form-item label="排除广告词">
          <el-input v-model="huntForm.exclude_words" placeholder="逗号分隔，如：广告,推广,直播预约,加V" />
          <span style="margin-left:10px;color:#909399;font-size:12px">标题含这些词的视频跳过（避开广告/引流号）</span>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-input-number v-model="huntForm.max_age_days" :min="0" :max="365" :step="7" />
          <span style="margin-left:10px;color:#909399;font-size:12px">只看最近 N 天发布的视频（0=不限）</span>
        </el-form-item>
        <el-form-item label="视频时长">
          <el-input-number v-model="huntForm.min_duration" :min="0" :max="600" :step="10" style="width:120px" />
          <span style="margin:0 8px;color:#909399">~</span>
          <el-input-number v-model="huntForm.max_duration" :min="0" :max="600" :step="10" style="width:120px" />
          <span style="margin-left:10px;color:#909399;font-size:12px">秒（0=不限）</span>
        </el-form-item>
        <el-form-item label="⏰ 设为定时">
          <el-switch v-model="huntForm.schedule_enable" />
          <span v-if="!huntForm.schedule_enable" style="margin-left:10px;color:#909399;font-size:12px">关闭=仅本次执行</span>
          <span v-else style="margin-left:10px;color:#e6a23c;font-size:12px">保存后按设定频率自动重复巡猎</span>
        </el-form-item>
        <template v-if="huntForm.schedule_enable">
          <el-form-item label="频率类型">
            <el-radio-group v-model="huntForm.schedule_type">
              <el-radio-button value="daily">每日定点</el-radio-button>
              <el-radio-button value="interval">每N分钟</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="huntForm.schedule_type === 'daily'" label="执行时刻">
            <el-time-picker v-model="huntForm.time_of_day" format="HH:mm" value-format="HH:mm" placeholder="每日执行时刻" />
          </el-form-item>
          <el-form-item v-else label="间隔分钟">
            <el-input-number v-model="huntForm.interval_minutes" :min="30" :max="1440" :step="30" />
            <span style="margin-left:10px;color:#909399;font-size:12px">建议 ≥120 分钟，避免触发风控</span>
          </el-form-item>
        </template>
        <el-form-item label="说明">
          <span style="color:#909399; font-size:12px">系统自动搜索关键词→发现同行视频→采集评论→识别意向客户→{{ huntForm.interact ? '点赞+AI回复评论（互动触达）→' : '' }}主页留痕→线索入库，全程无人值守</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showHuntDialog = false">取消</el-button>
        <el-button type="primary" :loading="huntSending" @click="submitHunt">启动巡猎</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Tasks',
  data() {
    return {
      showCreateDialog: false,
      showCollectDialog: false,
      showDmDialog: false,
      showLiveDialog: false,
      showHuntDialog: false,
      showSelfHeatDialog: false,
      saving: false,
      collecting: false,
      dmSending: false,
      liveSending: false,
      huntSending: false,
      selfHeatSending: false,
      shLoading: false,
      scheduleSending: false,
      loading: false,
      tasks: [],
      overview: {},
      scheduledHunts: [],
      accounts: [],
      newTask: {
        task_type: 'follow',
        account_id: null,
        target_url: ''
      },
      dmForm: {
        account_id: null,
        max_leads: 20
      },
      liveForm: {
        account_id: null,
        live_url: '',
        duration: 60
      },
      huntForm: {
        account_id: null,
        platform: 'douyin',
        keywordsText: '本地生活\n餐饮门店\n美业服务\n汽车美容\n家居建材',
        max_videos: 5,
        max_comments: 50,
        interact: true,
        max_interact: 5,
        video_comment: false,
        comment_image: '',
        source_type: 'search',
        source: '',
        schedule_enable: false,
        schedule_type: 'daily',
        time_of_day: '09:00',
        interval_minutes: 120,
        exclude_words: '',
        max_age_days: 0,
        min_duration: 0,
        max_duration: 0,
        edit_id: null
      },
      selfHeatForm: {
        account_id: null,
        max_replies: 10,
        max_follows: 10
      },
      collectForm: {
        account_id: null,
        video_url: '',
        max_comments: 200
      },
      filterPlatform: '',
      pollTimer: null
    }
  },
  computed: {
    // 按当前筛选平台过滤账号下拉
    filteredAccounts() {
      if (!this.filterPlatform) return this.accounts
      return this.accounts.filter(a => (a.platform || 'douyin') === this.filterPlatform)
    },
    // 巡猎对话框：按所选平台过滤账号
    accountsByPlatform() {
      const p = this.huntForm.platform || 'douyin'
      return this.accounts.filter(a => (a.platform || 'douyin') === p)
    }
  },
  created() {
    this.loadTasks()
    this.loadAccounts()
    this.loadOverview()
    this.loadScheduledHunts()
    // auto refresh every 5s so running tasks show live status
    this.pollTimer = setInterval(() => { this.loadTasks(false); this.loadOverview(); this.loadScheduledHunts() }, 10000)
  },
  beforeUnmount() {
    if (this.pollTimer) clearInterval(this.pollTimer)
  },
  methods: {
    async loadTasks(showLoading = true) {
      if (showLoading) this.loading = true
      try {
        const params = {}
        if (this.filterPlatform) params.platform = this.filterPlatform
        this.tasks = await api.get('/tasks/', { params })
      } catch (e) {
        if (showLoading) this.$message.error('加载任务失败: ' + e.message)
      } finally {
        if (showLoading) this.loading = false
      }
    },
    async loadOverview() {
      try {
        this.overview = await api.get('/tasks/overview')
      } catch (e) {
        // 概览失败不阻塞
      }
    },
    async loadAccounts() {
      try {
        this.accounts = await api.get('/accounts/')
      } catch (e) {
        this.$message.error('加载账号失败: ' + e.message)
      }
    },
    getStatusType(status) {
      const map = {
        completed: 'success',
        running: 'primary',
        pending: 'info',
        failed: 'danger',
        cancelled: 'warning'
      }
      return map[status] || 'info'
    },
    statusText(status) {
      const map = {
        completed: '已完成',
        running: '运行中',
        pending: '等待中',
        failed: '失败',
        cancelled: '已取消'
      }
      return map[status] || status
    },
    typeText(type) {
      const map = {
        follow: '关注',
        like: '点赞',
        comment: '评论',
        message: '私信',
        view: '浏览',
        collect_comments: '采集评论'
      }
      return map[type] || type
    },
    platformText(p) {
      const map = { douyin: '抖音', kuaishou: '快手', xhs: '小红书' }
      return map[p] || p || '抖音'
    },
    platformType(p) {
      const map = { douyin: '', kuaishou: 'warning', xhs: 'danger' }
      return map[p] || 'info'
    },
    async createTask() {
      if (!this.newTask.account_id || !this.newTask.target_url) {
        this.$message.warning('请填写账号和目标URL')
        return
      }
      this.saving = true
      try {
        const t = await api.post('/tasks/', this.newTask)
        this.tasks.unshift(t)
        this.showCreateDialog = false
        this.newTask = { task_type: 'follow', account_id: null, target_url: '' }
        this.$message.success('任务创建成功，后台自动执行中')
      } catch (e) {
        this.$message.error('创建失败: ' + e.message)
      } finally {
        this.saving = false
      }
    },
    async submitCollect() {
      if (!this.collectForm.account_id || !this.collectForm.video_url) {
        this.$message.warning('请填写账号和视频URL')
        return
      }
      this.collecting = true
      try {
        const r = await api.post('/leads/collect', this.collectForm)
        this.$message.success(r.message || '采集任务已提交')
        this.showCollectDialog = false
        this.collectForm = { account_id: null, video_url: '', max_comments: 200 }
        this.loadTasks()
      } catch (e) {
        this.$message.error('提交失败: ' + e.message)
      } finally {
        this.collecting = false
      }
    },
    async cancelTask(task) {
      try {
        const t = await api.post(`/tasks/${task.id}/cancel`)
        Object.assign(task, t)
        this.$message.success('任务已取消')
      } catch (e) {
        this.$message.error('取消失败: ' + e.message)
      }
    },
    async submitSelfHeat() {
      if (!this.selfHeatForm.account_id) {
        this.$message.warning('请选择执行账号')
        return
      }
      this.selfHeatSending = true
      try {
        const payload = JSON.stringify({
          max_replies: this.selfHeatForm.max_replies,
          max_follows: this.selfHeatForm.max_follows,
          max_videos: 5
        })
        const t = await api.post('/tasks/', {
          account_id: this.selfHeatForm.account_id,
          platform: 'douyin',
          task_type: 'self_heat',
          target_url: payload
        })
        this.$message.success('自热互动任务已提交，后台自动执行')
        this.showSelfHeatDialog = false
        this.loadTasks()
      } catch (e) {
        this.$message.error('提交失败: ' + e.message)
      } finally {
        this.selfHeatSending = false
      }
    },
    async submitDm() {
      if (!this.dmForm.account_id) {
        this.$message.warning('请选择执行账号')
        return
      }
      this.dmSending = true
      try {
        const r = await api.post('/leads/dm-followup', this.dmForm)
        this.$message.success(r.message || '私信任务已提交')
        this.showDmDialog = false
        this.loadTasks()
      } catch (e) {
        this.$message.error('提交失败: ' + e.message)
      } finally {
        this.dmSending = false
      }
    },
    async submitLive() {
      if (!this.liveForm.account_id || !this.liveForm.live_url) {
        this.$message.warning('请填写账号和直播间URL')
        return
      }
      this.liveSending = true
      try {
        const r = await api.post('/leads/live-capture', this.liveForm)
        this.$message.success(r.message || '直播采集任务已提交')
        this.showLiveDialog = false
        this.liveForm = { account_id: null, live_url: '', duration: 60 }
        this.loadTasks()
      } catch (e) {
        this.$message.error('提交失败: ' + e.message)
      } finally {
        this.liveSending = false
      }
    },
    async openHuntDialog(asSchedule = false, row = null) {
      // 打开巡猎对话框：普通巡猎拉取行业词库；定时巡猎新建/编辑
      if (row) {
        // 编辑已有定时任务
        this.huntForm = {
          account_id: row.account_id,
          platform: row.platform || 'douyin',
          keywordsText: (row.keywords || []).join('\n'),
          max_videos: row.max_videos,
          max_comments: row.max_comments,
          interact: row.interact,
          max_interact: row.max_interact,
          video_comment: row.video_comment,
          comment_image: row.comment_image || '',
          source_type: row.source_type || 'search',
          source: row.source || '',
          schedule_enable: true,
          schedule_type: row.schedule_type || 'daily',
          time_of_day: row.time_of_day || '09:00',
          interval_minutes: row.interval_minutes || 120,
          edit_id: row.id
        }
        this.showHuntDialog = true
        return
      }
      this.huntForm.edit_id = null
      if (!asSchedule) {
        try {
          const r = await api.get('/leads/keywords')
          if (r && r.device && r.process) {
            const defaultText = [...r.device, ...r.process].slice(0, 30).join('\n')
            this.huntForm.keywordsText = defaultText
          }
        } catch (e) {
          // 拉取失败则保留默认词
        }
      }
      this.showHuntDialog = true
    },
    async submitHunt() {
      if (!this.huntForm.account_id) {
        this.$message.warning('请选择执行账号')
        return
      }
      const keywords = this.huntForm.keywordsText.split('\n').map(k => k.trim()).filter(k => k)
      const isSearch = (this.huntForm.source_type || 'search') === 'search'
      if (isSearch && !keywords.length) {
        this.$message.warning('请填写至少一个行业关键词')
        return
      }
      const finalKeywords = keywords.length ? keywords : ['信息流']
      // 定时模式：保存到 scheduled-hunts（不立即执行，到点自动触发）
      if (this.huntForm.schedule_enable) {
        this.scheduleSending = true
        try {
          const body = {
            name: '定时巡猎',
            account_id: this.huntForm.account_id,
            platform: this.huntForm.platform || 'douyin',
            keywords: finalKeywords,
            max_videos: this.huntForm.max_videos,
            max_comments: this.huntForm.max_comments,
            interact: this.huntForm.interact,
            max_interact: this.huntForm.max_interact,
            video_comment: this.huntForm.video_comment,
            comment_image: this.huntForm.comment_image || '',
            source_type: this.huntForm.source_type || 'search',
            source: this.huntForm.source || '',
            schedule_type: this.huntForm.schedule_type,
            time_of_day: this.huntForm.time_of_day || '09:00',
            interval_minutes: this.huntForm.interval_minutes || 120,
            enabled: true
          }
          if (this.huntForm.edit_id) {
            await api.put(`/scheduled-hunts/${this.huntForm.edit_id}`, body)
            this.$message.success('定时巡猎已更新')
          } else {
            await api.post('/scheduled-hunts', body)
            this.$message.success('定时巡猎已创建，到点自动执行')
          }
          this.showHuntDialog = false
          this.loadScheduledHunts()
          this.huntForm.schedule_enable = false
          this.huntForm.edit_id = null
        } catch (e) {
          this.$message.error('保存失败: ' + e.message)
        } finally {
          this.scheduleSending = false
        }
        return
      }
      this.huntSending = true
      try {
        const r = await api.post('/leads/hunt', {
          account_id: this.huntForm.account_id,
          platform: this.huntForm.platform || 'douyin',
          keywords: finalKeywords,
          max_videos: this.huntForm.max_videos,
          max_comments: this.huntForm.max_comments,
          interact: this.huntForm.interact,
          max_interact: this.huntForm.max_interact,
          video_comment: this.huntForm.video_comment,
          comment_image: this.huntForm.comment_image || '',
          source_type: this.huntForm.source_type || 'search',
          source: this.huntForm.source || '',
          exclude_words: (this.huntForm.exclude_words || '').split(/[,，]/).map(s => s.trim()).filter(Boolean),
          max_age_days: this.huntForm.max_age_days || 0,
          min_duration: this.huntForm.min_duration || 0,
          max_duration: this.huntForm.max_duration || 0
        })
        this.$message.success(r.message || '巡猎任务已提交')
        this.showHuntDialog = false
        this.loadTasks()
      } catch (e) {
        this.$message.error('提交失败: ' + e.message)
      } finally {
        this.huntSending = false
      }
    },
    // ---- 定时巡猎 ----
    async loadScheduledHunts() {
      this.shLoading = true
      try {
        const r = await api.get('/scheduled-hunts')
        this.scheduledHunts = r.items || []
      } catch (e) {
        // 静默
      } finally {
        this.shLoading = false
      }
    },
    async toggleScheduledHunt(row) {
      try {
        const r = await api.post(`/scheduled-hunts/${row.id}/toggle`)
        Object.assign(row, r)
        this.$message.success(r.enabled ? '定时巡猎已启用' : '定时巡猎已停用')
      } catch (e) {
        this.$message.error('操作失败: ' + e.message)
      }
    },
    async runScheduledHuntNow(row) {
      try {
        const r = await api.post(`/scheduled-hunts/${row.id}/run-now`)
        this.$message.success(r.message || '已触发')
        this.loadTasks()
      } catch (e) {
        this.$message.error('触发失败: ' + e.message)
      }
    },
    async deleteScheduledHunt(row) {
      try {
        await this.$confirm(`确定删除定时巡猎「${row.name}」？`, '删除确认', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await api.delete(`/scheduled-hunts/${row.id}`)
        this.$message.success('已删除')
        this.loadScheduledHunts()
      } catch (e) {
        this.$message.error('删除失败: ' + e.message)
      }
    }
  }
}
</script>

<style scoped>
.tasks {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.hdr-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.ov-card {
  text-align: center;
  padding: 6px 0;
}
.ov-num {
  font-size: 26px;
  font-weight: 700;
  color: #409eff;
  line-height: 1.2;
}
.ov-label {
  font-size: 13px;
  font-weight: 600;
  margin-top: 4px;
}
.ov-sub {
  font-size: 11px;
  color: var(--el-text-color-placeholder, #909399);
  margin-top: 2px;
}
/* 手机端：按钮整宽排布，避免堆叠误点 */
@media (max-width: 767px) {
  .card-header { align-items: flex-start; }
  .card-header > span { width: 100%; }
  .hdr-actions { width: 100%; justify-content: flex-start; }
  .hdr-actions .el-button { flex: 1 1 45%; margin: 0; }
  .hdr-actions .el-select { flex: 1 1 100%; width: 100%; margin-bottom: 2px; }
  .hdr-actions .el-select .el-input { width: 100%; }
  .ov-num { font-size: 22px; }
}
</style>
